"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SubscriptionSeats = void 0;
const react_1 = __importDefault(require("react"));
const react_router_dom_1 = require("react-router-dom");
const i18n_1 = require("@app/util/i18n");
const util_1 = require("@app/util");
const _ui_1 = require("@ui");
const tiers_hooks_1 = require("@app/util/hooks/tiers-hooks");
function SubscriptionSeats({ isOrg = false } = {}) {
    const organization = (0, tiers_hooks_1.useOrganization)();
    const seatLimit = organization?.seatLimit || 0;
    const employeeCount = organization?.employeeCount || 0;
    const history = (0, react_router_dom_1.useHistory)();
    const canUpdateTiers = (0, tiers_hooks_1.useCanUpdateTiers)();
    const isUsingTiers = (0, tiers_hooks_1.useIsUsiningTiers)();
    const isTrial = (0, tiers_hooks_1.useIsTrial)();
    if (!canUpdateTiers || !isUsingTiers || isTrial) {
        return null;
    }
    return (react_1.default.createElement("div", { style: { cursor: 'pointer' }, onClick: () => {
            history.push(util_1.miscUtil.isDayswapsProInterface() ? '/organization/invoicing' : '/invoicing');
        } },
        react_1.default.createElement(_ui_1.Flex, { direction: _ui_1.Flex.DIRECTION.COLUMN },
            react_1.default.createElement(_ui_1.Flex, { align: _ui_1.Flex.POSITION.CENTER },
                react_1.default.createElement(_ui_1.Text, { type: _ui_1.Text.TYPES.BODY_MEDIUM, weight: _ui_1.Text.WEIGHTS.BOLD, color: isOrg ? _ui_1.Text.COLORS.WHITE : _ui_1.Text.COLORS.BLACK },
                    (0, i18n_1.t)('NUMBER_OF_SEATS'),
                    ":")),
            react_1.default.createElement(_ui_1.Spacing, { size: _ui_1.Spacing.SIZES.SIZE_2, type: _ui_1.Spacing.TYPES.VERTICAL }),
            react_1.default.createElement(_ui_1.Text, { type: _ui_1.Text.TYPES.BODY_MEDIUM, weight: _ui_1.Text.WEIGHTS.SEMI_MEDIUM, color: isOrg ? _ui_1.Text.COLORS.WHITE : _ui_1.Text.COLORS.BLACK },
                employeeCount,
                "/",
                seatLimit,
                " ",
                (0, i18n_1.t)('USED_UP').toLocaleLowerCase()))));
}
exports.SubscriptionSeats = SubscriptionSeats;
